import {type DocumentRevision} from '../../../history'
import {isLiveEditEnabled} from '../utils/isLiveEditEnabled'
import {type OperationImpl} from './types'

export const restore: OperationImpl<[fromRevision: DocumentRevision]> = {
  disabled: (): false => false,
  execute: ({historyStore, schema, idPair, typeName}, fromRevision: DocumentRevision) => {
    const targetId = idPair.versionId
      ? idPair.versionId
      : isLiveEditEnabled(schema, typeName)
        ? idPair.publishedId
        : idPair.draftId

    return historyStore.restore(idPair.publishedId, targetId, fromRevision)
  },
}
